export enum EmergencyAlarmActivationMethod {
  App = 'App',
  DeviceButton = 'DeviceButton',
  AppAndButton = 'AppAndButton',
}
